import { render, staticRenderFns } from "./InquiryTemplate.vue?vue&type=template&id=fbc7bdd4&"
import script from "./InquiryTemplate.vue?vue&type=script&lang=ts&"
export * from "./InquiryTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports